'use strict';

var I18N = require('utils/i18n');
var OOP = require('utils/oop');
var AbstractTableView = require('components/common/views/abstract_table_view');
var BaseDeviceListView = require('components/devices/views/common/base_device_list_view');
var FilterController = require('components/devices/controllers/filter');
var DeviceModels = require('models/devices');
var Models = require('models/tools');
var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');
var Utils = require('components/common/utils');

module.exports = OOP.extend(AbstractTableView, {
    initialize: function (options) {
        this.collection = new Models.Ranking.Collection(options.data.get('items'));
        this.itemCount = options.data.get('count');
        this.filterData = options.filterData;

        AbstractTableView.prototype.initialize.apply(this, [this.getTableConfiguration()]);
        this.listResult = options.data;
    },

    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click .js-tab-btn-options': 'configureColumns',
            'click .js-tab-btn-hide': 'hide',
            'click .js-tab-btn-show-all': 'showAll',

            'click .js-tab-btn-invite': function (e) {
                this.execDeviceCtxMenu('invite', e);
            },
            'click .js-tab-btn-group': function (e) {
                this.execDeviceCtxMenu('group', e);
            },
            'click .js-tab-btn-alarm': function (e) {
                this.execDeviceCtxMenu('alarm', e);
            },
            'click .js-tab-btn-config': function (e) {
                this.execDeviceCtxMenu('config', e);
            },
            'click .js-tab-btn-write': function (e) {
                this.execDeviceCtxMenu('write', e);
            },
        });
    },

    doDeleteSelectedRows: function (modelsToDelete, defer) {
        // create devices from models to delete
        var deviceMap = {};

        var models = _.compact(
            _.map(modelsToDelete, function (m) {
                var attrs = $.extend(false, {}, m.attributes);
                if (deviceMap[attrs.device_id]) return undefined;
                attrs.id = attrs.device_id;
                deviceMap[attrs.id] = true;
                return new DeviceModels.Model(attrs);
            })
        );

        return this.base.doDeleteSelectedRows(models, defer);
    },

    afterDeleteSelectedRows: function () {
        Backbone.history.loadUrl(Backbone.history.fragment);
    },

    execDeviceCtxMenu: function (cmd, e) {
        e.preventDefault();
        // create a fake controller
        var controller = new FilterController();

        // create a fake base device list view with selected devices (and select them)
        var devices = this.getSelectedDevices();
        var deviceCollection = new DeviceModels.Collection(
            _.map(devices, function (x) {
                return new DeviceModels.Model(x);
            })
        );
        deviceCollection.selectAll();

        var fakeClass = OOP.extend(BaseDeviceListView, {
            getTableConfiguration: function () {
                return {
                    title: '',
                };
            },
        });

        var view = new fakeClass(
            {
                deviceCategory: null,
                controller: controller,
                collection: deviceCollection,
                title: '',
            },
            {}
        );

        // get the function handling selected event and call it
        var events = view.events;
        var key = 'click .js-tab-btn-' + cmd;
        var fct = events[key];
        if (!fct) return;
        fct = view[fct];
        fct.apply(view, [e]);
    },

    updateCSVlink: function () {
        this.ui.btnCSVdownload.attr('href', this.getCSVLink());
    },

    getCSVLink: function () {
        var objs = Object.values(this.collection.selected);
        var ids = encodeURIComponent(
            Misc.selectWhere(objs, undefined, function (x) {
                return x.id;
            }).join(',')
        );

        return (
            '/api/v1/devices/ranking/csv?' +
            'priority=' +
            (this.filterData.priority || '') +
            '&rules=' +
            encodeURIComponent((this.filterData.rule || []).join(',')) +
            '&filter=' +
            encodeURIComponent(JSON.stringify(this.filterData.filter || '')) +
            '&ids=' +
            ids +
            '&sort_col=' +
            this.filterData.sortCol +
            '&sort_desc=' +
            (this.filterData.sortDesc ? '1' : '0') +
            '&lang=' +
            AppState.getUserLanguage()
        );
    },

    getSelectedDevices: function () {
        var deviceMap = {};

        var devices = [];
        _.each(this.collection.selected, function (item) {
            devices.push(item.get('device_id'));
            deviceMap[item.get('device_id')] = item;
        });
        devices = _.unique(devices);
        return _.map(devices, function (devID) {
            var item = deviceMap[devID];
            var newObj = {};
            _.each(item.attributes, function (value, key) {
                newObj[key] = value;
            });
            newObj.id = devID;
            return newObj;
        });
    },

    hide: function (e) {
        e.preventDefault();

        var self = this;
        var devices = _.map(this.getSelectedDevices(), function (dev) {
            return dev.id;
        });
        $.when(App.request('ranking:devices:hide', devices)).done(function (r) {
            if (App.errIfUndefined(r, I18N.TR('Einstellungen konnten nicht gespeichert werden.'), false)) return;
            self.gotoPage(1);
        });
    },

    showAll: function () {
        var self = this;

        Utils.showConfirmationDialog({
            title: I18N.TR('Ausgeblendete Geräte anzeigen'),
            hint: I18N.TR('Wollen Sie wirklich alle ausgeblendeten Geräte wieder anzeigen?'),
            action_label: I18N.TR('Einblenden'),

            action_cb: function () {
                $.when(App.request('ranking:devices:show:all')).done(function (r) {
                    if (App.errIfUndefined(r, I18N.TR('Einstellungen konnten nicht gespeichert werden.'), false))
                        return;
                    self.gotoPage(1);
                });
            },
        });
    },

    getColumnsDialogConfiguration: function () {
        var self = this;
        // add generic (device independent) columns
        return {
            category: 'ranking',
            columnCategory: undefined,
            update_cb: function (columns) {
                AppState.setSelectedColumns('ranking', columns);
                self.options.columns = self.getTableColumns(AppState.selectedColumns('ranking'));
                self.render();
            },
        };
    },

    getCurrentTargetID: function (e) {
        var id = this.base.getCurrentTargetID(e);
        var row = this.collection.get(id);
        return row.get('device_id');
    },

    modelAction: function (e, deviceID) {
        Misc.modelAction(e, deviceID, App, AppState);
    },

    configureColumns: function (e) {
        e.preventDefault();

        var self = this;
        AppState.requireColumns(function () {
            Utils.showConfigureColumnsDialog(self.getColumnsDialogConfiguration());
        });
    },

    refreshTable: function (e) {
        Backbone.history.loadUrl(this.lastURL || Backbone.history.fragment);
    },

    getTableColumns: function (additionalColumns) {
        var rankingColumns = [
            {
                id: '#_name',
                name: 'Name', // i18n.TR('Name')
                alwaysVisible: true,
                displayMethod: {
                    method: 'device',
                    attrID: 'device_id',
                    attrName: 'name',
                    attrCategory: 'category',
                },
            },
            {
                id: '#_rule_name',
                name: 'Regel', // i18n.TR('Regel')
            },
            {
                id: '#_priority',
                name: 'Priorität', // i18n.TR('Priorität')
                displayMethod: 'priority',
            },
            {
                id: '#_ranking',
                name: 'Bewertung', // i18n.TR('Bewertung')
            },
            {
                id: '#_begin_time',
                name: 'Startzeit', // i18n.TR('Startzeit')
                displayMethod: 'timestamp',
            },
            {
                id: '#_end_time',
                name: 'Endzeit', // i18n.TR('Endzeit')
                displayMethod: 'timestamp',
            },
        ];

        _.each(additionalColumns, function (col) {
            if (col.id == '#_name') return;
            rankingColumns.push(col);
        });

        return rankingColumns;
    },

    getTableConfiguration: function () {
        return {
            title: I18N.TR('Geräte ({{itemCount}})'),

            sortCol: this.options.filterData.sortCol,
            sortDesc: this.options.filterData.sortDesc,
            currentPage: this.options.filterData.page || 1,
            listResult: this.listResult,
            itemCount: this.itemCount,
            itemsPerPage: AppState.getItemsPerPage(),
            CSVLink: this.getCSVLink(),

            columns: this.getTableColumns(AppState.selectedColumns('ranking')),
            getSortColumn: function (c) {
                if (_.contains(['groups', '#_groups'], c.id)) {
                    return undefined;
                }

                // corresponds with rankingSortCols in device_ranking.go
                switch (c.id) {
                    case '#_name':
                        return 'ranking2';
                    case '#_rule_name':
                        return 'ranking3';
                    case '#_priority':
                        return 'ranking4';
                    case '#_ranking':
                        return 'ranking1';
                    case '#_begin_time':
                        return 'ranking5';
                    case '#_end_time':
                        return 'ranking6';
                    default:
                        var tmp = Misc.columnNameToField(c.id);
                        return tmp;
                }
            },

            hasRefreshButton: true,
            hasSelectionButtons: true,
            selectionButtons: [
                { ButtonText: I18N.TR('Ausblenden'), ButtonID: 'hide', ButtonIcon: 'fa fa-eye-slash' },
                { ButtonText: I18N.TR('Freigeben'), ButtonID: 'invite', ButtonIcon: 'md md-group' },
                { ButtonText: I18N.TR('Labels'), ButtonID: 'group', ButtonIcon: 'fa fa-tags' },
                { ButtonText: I18N.TR('Alarm'), ButtonID: 'alarm', ButtonIcon: 'fa fa-bell-o' },
                {
                    ButtonText: I18N.TR('Werte auswählen'),
                    ButtonID: 'config',
                    ButtonIcon: 'glyphicon glyphicon-cloud-upload',
                },
                { ButtonText: I18N.TR('Wert schreiben'), ButtonID: 'write', ButtonIcon: 'glyphicon glyphicon-pencil' },
            ],
            customButtons: [
                { ButtonIcon: 'fa fa-eye', ButtonID: 'show-all' },
                { ButtonIcon: 'fa fa-cog', ButtonID: 'options' },
                { ButtonIcon: 'fa fa-filter', ButtonID: 'filter' },
            ],

            displayMethods: {
                priority: function (value, model) {
                    switch (value) {
                        case 1:
                            return I18N.TR('Niedrig');
                        case 2:
                            return I18N.TR('Mittel');
                        case 3:
                            return I18N.TR('Hoch');
                    }
                },
                timestamp: function (value, model) {
                    return Misc.formatDate(value);
                },
            },
        };
    },
});
